/**
 * Web only: takes the token of `/login-link?token=…` out of the address bar
 * before anything else reads it — Bugsnag (which reports the page URL and
 * records navigations), the history a later visitor can scroll, the
 * `Referer` of the page's next requests. Called before Bugsnag starts; the
 * screen then reads the token from here instead of from the URL.
 */
let captured = null
let noReferrer = null

export const captureLoginLinkToken = (window = globalThis.window) => {
    const location = window?.location
    if (!location || !/^\/login-link\/?$/.test(location.pathname)) return

    const params = new URLSearchParams(location.search)
    const token = params.get("token")
    if (!token) return

    captured = token
    params.delete("token")
    const query = params.toString()
    window.history.replaceState(
        window.history.state,
        "",
        location.pathname + (query ? `?${query}` : "") + location.hash
    )

    noReferrer = window.document?.createElement("meta") ?? null
    if (noReferrer) {
        noReferrer.name = "referrer"
        noReferrer.content = "no-referrer"
        window.document.head.appendChild(noReferrer)
    }
}

export const capturedLoginLinkToken = () => captured

/**
 * Once redeemed, a later visit to /login-link must not find it again, and
 * the rest of the session gets its usual `Referer` back.
 */
export const forgetLoginLinkToken = () => {
    captured = null
    noReferrer?.remove()
    noReferrer = null
}
